import React, {useEffect, useState} from "react";
import {classNames, updateQueryFields} from "../../../util/util-helpers";
import ModalDefault from "../modal-default";
import ResourceTable from "../../resource-table";
import TableCardFooter from "../../resource-table/table-components/table-card-footer";
import Pagination from "../../resource-table/table-components/pagination";
import {getDialogResource} from "../../../../data/actions/dialogResource";
import LocalStorage from "../../../util/localStorage";
import {ArrowPathIcon} from "@heroicons/react/24/outline";
import {useDispatch, useSelector} from "react-redux";
import useQuery from "../../../../hooks/use-query";
import {FieldsManager} from "../../../../data/services/fields";
import FieldsForm from "../../fields/fields-form";
import NoRecordsTable from "../../no-records-found/no-records-table";
import Button from "../../button";
import FunnelIcon from "@heroicons/react/24/outline/FunnelIcon";
import ActiveFilters from "../../resource-table/table-components/active-filters";

// TODO: This component is work in progress
// Test no records
// Todo make new filter component

export default function ResourceTableDialogNew({
                                                   show,
                                                   title,
                                                   resourcePath,
                                                   fields,
                                                   translate,
                                                   tableKey, // Required fields
                                                   widthClass = "max-w-5xl",
                                                   onView,
                                                   onCreate,
                                                   hasCreatePerm = true,
                                                   onEdit,
                                                   onDelete,
                                                   onRowClick,
                                                   onSelectRow,
                                                   selectedRows,
                                                   onSelectAllClick,
                                                   onSubmitButton,
                                                   buttonLabel,
                                                   buttonDisabled,
                                                   onSecondaryButtonClick,
                                                   secondaryButtonLabel,
                                                   secondaryButtonDisabled,
                                                   getCustomActions,
                                                   options,
                                                   querySearchFieldsList,
                                                   getQueryFields,
                                                   querySelects,
                                                   maxHeightClass = getQueryFields && Object.keys(getQueryFields).some(item => !['sort', 'sortBy', 'limit', 'offset'].includes(item))
                                                       ? "max-h-[calc(100vh-15rem)]"
                                                       : "max-h-[calc(100vh-14rem)]",
                                                   onUpdateQueryFields,
                                                   hideRowsPerPage = true,
                                                   queryStoragePath,
                                                   hasViewPerm = true,
                                                   hasEditPerm = true,
                                                   hasDeletePerm = true,
                                                   hasRestorePerm = true,
                                                   onClose,
                                                   htmlBefore,
                                                   htmlAfter,
                                                   queryRef,
                                                   excludedActiveFilters,
                                                   omitActiveFilters,
                                                   saveTableOptions,
                                                   additionalButtons,
                                                   dialogResource,
                                                   getResource
                                               }) {

    const dispatch = useDispatch();
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [queryFields, setQueryFields] = useQuery(getQueryFields, queryStoragePath);

    let query = FieldsManager.getFieldKeyValues(queryFields);

    const resource = dialogResource
        ? dialogResource
        : useSelector(state => state.dialogResource);

    const data = resource?.data?.list ?? [];
    const count = resource?.data?.count;

    const isLoading = !!resource?.isLoading;

    function handleQueryChange(name, value) {
        if (onUpdateQueryFields) {
            setQueryFields(onUpdateQueryFields(queryFields, name, value))
        } else {
            setQueryFields(updateQueryFields(queryFields, name, value))
        }
    }

    /** Data Events
     ================================================================= */
    function fetchData() {
        if (querySearchFieldsList && querySearchFieldsList.length) {
            const searchFields = {};
            querySearchFieldsList.forEach(it => {
                if (query[it]) {
                    searchFields[it] = query[it];
                    delete query[it];
                }
            });

            query.searchFields = JSON.stringify(searchFields);
        }

        const requestData = {
            user: LocalStorage.get("user"),
            resource: resourcePath,
            query: query
        }

        if (getResource) {
            dispatch(getResource(requestData));
        } else {
            dispatch(getDialogResource(requestData));
        }
    }

    function handleClearFiltersClick() {
        const queryFieldsUpdate = Object.values(queryFields).reduce((memo, it) => {
            if (!["sort", "sortBy", "limit", "offset"].includes(it.name)) {
                it.value = "";
            }

            memo[it.name] = it;
            return memo;
        }, {})

        setQueryFields(queryFieldsUpdate);
    }

    /** Lifecycle
     ================================================================= */
    useEffect(() => {
        if (show) {
            if (queryRef) {
                queryRef.current = query; // for passing query to parent without update state
            }
            fetchData();
        }
    }, [show, queryFields])

    return (
        <React.Fragment>
            <ModalDefault
                show={show}
                widthClass={widthClass}
                title={title}
                onClose={onClose}
                closeButtonLabel={translate("btn.close")}
                buttonDisabled={buttonDisabled}
                limitHeight={false}
                onButtonClick={onSubmitButton}
                buttonLabel={buttonLabel}
                secondaryButtonLabel={secondaryButtonLabel}
                onSecondaryButtonClick={onSecondaryButtonClick}
                secondaryButtonDisabled={secondaryButtonDisabled}
                hideDialogFooter={!buttonLabel}
            >
                {htmlBefore}

                {!!getQueryFields && (
                    <>
                        {!omitActiveFilters && (
                            <div className="flex items-center px-4 h-9">
                                <ActiveFilters
                                    excludedFields={['limit', 'sort', 'sortBy', 'offset'].concat(excludedActiveFilters ?? [])}
                                    filterFields={queryFields}
                                    onLabelClick={handleQueryChange}
                                    onClearFiltersClick={handleClearFiltersClick}
                                    translate={translate}
                                />
                            </div>
                        )}

                        <div className="flex items-start gap-2 px-4 py-2">
                            <div
                                className="hidden md:grid xl:hidden grid-cols-2 3xl:grid-cols-5 gap-2 flex-1 max-w-[100rem]">
                                <FieldsForm
                                    fieldsState={queryFields}
                                    onChange={handleQueryChange}
                                    excludeFields={['limit', 'sort', 'sortBy', 'offset']}
                                    translate={translate}
                                    selects={querySelects}
                                />
                            </div>

                            <div className="hidden xl:grid grid-cols-3 3xl:grid-cols-5 gap-2 flex-1 max-w-[100rem]">
                                <FieldsForm
                                    fieldsState={queryFields}
                                    onChange={handleQueryChange}
                                    excludeFields={['limit', 'sort', 'sortBy', 'offset']}
                                    translate={translate}
                                    selects={querySelects}
                                />
                            </div>


                            <div className="ml-auto space-x-2">
                                <button
                                    onClick={() => setIsFilterModalOpen(true)}
                                    className="md:hidden btn btn-outline-secondary px-2"
                                >
                                    <FunnelIcon className="size-5"/>
                                </button>

                                <button
                                    className={
                                        classNames(
                                            "btn btn-header z-10",
                                        )
                                    }
                                    onClick={fetchData}
                                >
                                    <ArrowPathIcon className={
                                        classNames(
                                            "w-5 h-5",
                                            isLoading ? "animate-spin" : undefined,
                                        )
                                    }/>
                                </button>
                            </div>


                            {/*<div className="grid py-2 gap-4 grid-cols-6 md:grid-cols-12 z-30 relative grow">*/}
                            {/*    <FieldsForm*/}
                            {/*        fieldsState={queryFields}*/}
                            {/*        onChange={handleQueryChange}*/}
                            {/*        excludeFields={['limit', 'sort', 'sortBy', 'offset']}*/}
                            {/*        translate={translate}*/}
                            {/*        selects={querySelects}*/}
                            {/*    />*/}

                            {/*<div className={"col-start-6 md:col-start-12 flex justify-end"}>*/}
                            {/*    <button*/}
                            {/*        className={*/}
                            {/*            classNames(*/}
                            {/*                "btn btn-header z-10",*/}
                            {/*            )*/}
                            {/*        }*/}
                            {/*        onClick={fetchData}*/}
                            {/*    >*/}
                            {/*        <ArrowPathIcon className={*/}
                            {/*            classNames(*/}
                            {/*                "w-5 h-5",*/}
                            {/*                isLoading ? "animate-spin" : undefined,*/}
                            {/*            )*/}
                            {/*        }/>*/}
                            {/*    </button>*/}
                            {/*</div>*/}
                            {/*</div>*/}

                            {additionalButtons}

                            {onCreate && (
                                <Button
                                    appearance={"primary"}
                                    onClick={onCreate}
                                    hasPerm={hasCreatePerm}
                                >
                                    {translate("btn.create_new")}
                                </Button>
                            )}
                        </div>
                    </>
                )}

                <ResourceTable
                    data={data}
                    maxHeightClass={maxHeightClass}
                    fields={fields}
                    translate={translate}
                    isLoading={isLoading}

                    hasViewPerm={hasViewPerm}
                    hasEditPerm={hasEditPerm}
                    hasDeletePerm={hasDeletePerm}
                    hasRestorePerm={hasRestorePerm}

                    options={options}
                    saveTableOptions={saveTableOptions}
                    queryFields={queryFields}
                    tableKey={tableKey}

                    onSortChange={(colName) => handleQueryChange('sortBy', colName)}


                    onSelectRow={onSelectRow}
                    onSelectAllClick={onSelectAllClick}
                    selectedRows={selectedRows}

                    onRowClick={onRowClick}
                    onView={onView}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    actions={getCustomActions}
                />

                <TableCardFooter
                    show={!(!data.length && !isLoading)}
                >
                    <Pagination
                        count={count}
                        hideRowsPerPage={hideRowsPerPage}
                        queryFields={queryFields}
                        isLoading={isLoading}
                        handleQueryChange={handleQueryChange}
                        translate={translate}
                    />
                </TableCardFooter>

                <NoRecordsTable
                    show={data.length === 0 && !isLoading}
                    canCreate={false}
                    title={translate('text.no_matching_records')}
                    onClearFilterClick={handleClearFiltersClick}
                    clearFilterBtnLabel={translate('text.clear_all_filters')}
                    clearFilterText={translate('text.try_without_filters')}
                    excludeFields={['limit', 'sort', 'sortBy', 'offset']}
                    filters={queryFields}
                />

                {/*{htmlAfter}*/}

                {(typeof htmlAfter === 'function') ? htmlAfter(fields, query) : htmlAfter}


                <ModalDefault
                    show={isFilterModalOpen}
                    widthClass={'max-w-lg'}
                    title={translate("text.all_filters")}

                    closeButtonLabel={translate('btn.close')}
                    onClose={() => {
                        setIsFilterModalOpen(false);
                    }}
                >
                    <div className="flex flex-col gap-4 p-4">
                        <FieldsForm
                            fieldsState={queryFields}
                            onChange={handleQueryChange}
                            excludeFields={['limit', 'sort', 'sortBy', 'offset']}
                            translate={translate}
                            selects={querySelects}
                        />
                    </div>
                </ModalDefault>
            </ModalDefault>
        </React.Fragment>
    );
}

